import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import { API } from "../api";
import {
  UPDATE_ADDRESS_MULTIPLE,
  UPDATE_ADDRESS_MULTIPLE_SUCCESS,
  UPDATE_ADDRESS_MULTIPLE_FAIL,
  GET_ADDRESS_LIST,
  GET_ADDRESS_LIST_SUCCESS,
  GET_ADDRESS_LIST_FAIL,
  ADD_ADDRESS,
  UPDATE_ADDRESS,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAIL,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAIL,
  ADD_VIRTUAL_LOCKER,
  ADD_VIRTUAL_LOCKER_SUCCESS,
  ADD_VIRTUAL_LOCKER_FAIL,
  GET_VIRTUAL_LOCKER,
  GET_VIRTUAL_LOCKER_SUCCESS,
  GET_VIRTUAL_LOCKER_FAIL,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAIL,
  DELETE_ADDRESS,
} from "../actions/AddressActions";
import {
  SET_DEFAULT_ADDRESS,
  SET_DEFAULT_ADDRESS_FAIL,
  SET_DEFAULT_ADDRESS_SUCCESS,
} from "../actions/AuthActions";

function* updateAddressMultiple(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.updateAddressMultiple, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: UPDATE_ADDRESS_MULTIPLE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({
      type: UPDATE_ADDRESS_MULTIPLE_FAIL,
      payload: { error: error },
    });
  }
}

function* getAddressList(action) {
  try {
    const response = yield call(API.getAddressList, action.payload);
    yield put({ type: GET_ADDRESS_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: GET_ADDRESS_LIST_FAIL, payload: { error: error } });
  }
}

function* addAddress(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.addAddress, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: ADD_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({ type: ADD_ADDRESS_FAIL, payload: { error: error } });
  }
}

function* updateAddress(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.updateAddress, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: UPDATE_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({ type: UPDATE_ADDRESS_FAIL, payload: { error: error } });
  }
}
function* deleteAddress(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.deleteAddress, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: DELETE_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: DELETE_ADDRESS_FAIL, payload: { error: error } });
  }
}

function* setDefaultAddress(action) {
  try {
    const response = yield call(API.setDefaultAddress, action.payload);
    yield put({ type: SET_DEFAULT_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: SET_DEFAULT_ADDRESS_FAIL, payload: { error: error } });
  }
}
function* setVirtualAddress(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload || {};
    const response = yield call(API.setVirtualAddress, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess(response.data?.data ?? response.data);
    }
    yield put({ type: ADD_VIRTUAL_LOCKER_SUCCESS, payload: response.data });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({ type: ADD_VIRTUAL_LOCKER_FAIL, payload: { error: error } });
  }
}
function* virtualAccept(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.virtualAccept, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({ type: GET_VIRTUAL_LOCKER_SUCCESS, payload: response.data });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({ type: GET_VIRTUAL_LOCKER_FAIL, payload: { error: error } });
  }
}

function* addressSaga() {
  yield takeLeading(UPDATE_ADDRESS_MULTIPLE, updateAddressMultiple);
  yield takeLatest(GET_ADDRESS_LIST, getAddressList);
  yield takeLeading(ADD_ADDRESS, addAddress);
  yield takeLeading(UPDATE_ADDRESS, updateAddress);
  yield takeLatest(SET_DEFAULT_ADDRESS, setDefaultAddress);
  yield takeLeading(ADD_VIRTUAL_LOCKER, setVirtualAddress);
  yield takeLeading(GET_VIRTUAL_LOCKER, virtualAccept);
  yield takeLatest(DELETE_ADDRESS, deleteAddress);
}
export default addressSaga;
